module.exports = "/images/vendor/flag-icon-css/flags/1x1/re.svg?01fea3b62ac2440a5785d9de95dbc3d9";